module.exports = __webpack_public_path__ + "public/img/Mobvista@1x.72010764.png";